<template>
  <v-row>
    <v-col cols="12" class="pa-6">
      <div class="d-flex" v-if="showAnswer">
        <v-badge
          bottom
          overlap
          icon="check"
          :color="answer.answer == null ? 'lighttext' : 'success'"
          class="mr-8"
        >
          <user-avatar size="40" :user="user"></user-avatar>
        </v-badge>
        <rating
          v-model="answer.answer"
          v-on:change="$emit('answer', $event)"
          :disabled="disabled"
          selectedColor="performance"
        ></rating>
        <v-btn
          fab
          small
          outlined
          :color="answer.feedback ? 'performance' : 'grey'"
          @click="$emit('feedback')"
          v-if="!disabled && answer.feedback"
        >
          <v-icon small>message</v-icon>
        </v-btn>
      </div>
      <div v-else class="subtitle-1">
        Waiting On Answer
      </div>
    </v-col>
  </v-row>
</template>

<script>
import Rating from "@/components/common/Rating";
export default {
  name: "AnnualReviewQuestionOpinionAnswer",
  components: { Rating },
  props: {
    answer: { type: Object },
    disabled: { type: Boolean, default: false },
    user: { type: Object },
    showAnswer: { type: Boolean, default: false }
  }
};
</script>
